import * as React from "react";
import { useEffect, useState } from "react";
import { PublicAmorgUser } from '../../amorg-common';
import { getActiveUser, refresh } from "../../api/authClientApi";
import { SingleColumnLayout } from '../_layouts/SingleColumnLayout';
import { PageHeader } from '../../designSystem/PageHeader';
import { P } from '../../designSystem/typography/Body';
import { clientAccessHelper } from '../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../_contexts/ProtectedPageContext';
import { UserPageWrapper } from '../_pageWrappers/UserPageWrapper';
import UserPanel from "../_components/userEditor/UserPanel";

export default function ProfilePage(): JSX.Element {
	return (
		<UserPageWrapper breadCrumbs={[{ text: 'Profilindstillinger', url: '' }]}>
			<ProfilePageContent />
		</UserPageWrapper>
	);
}

function ProfilePageContent(): JSX.Element {

	const [activeUser, setActiveUser] = useState<PublicAmorgUser>(undefined);

	const ctxUser = React.useContext(ProtectedPageContext).user;
	const hasAccess = clientAccessHelper.hasAllPermissions(ctxUser, ['EditUser']);

	useEffect(() => {
        getData();
    }, []);

	const getData = async () => {
		await refresh();
		const activeUser = await getActiveUser();
		setActiveUser(activeUser);
	};

    const handleSelectedUserUpdated = async () => {
		await getData();
	} 

	if (!hasAccess)
		return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

	return (
		<>
			<PageHeader narrow headerText="Profilindstillinger" />
		<SingleColumnLayout narrow>
			<>
				{activeUser &&
					<UserPanel 
						activeUser={activeUser}
						targetUserId={activeUser.id}
						onSelectedUserUpdated={handleSelectedUserUpdated} />
				}
			</>
		</SingleColumnLayout>
		</>
	);
}